import { useStep } from "../../context/stepContext";
import { useChair } from "../../context/ChairContext";
import { useCart } from "../../context/CartContext";
import React, { useEffect, useRef, useState } from "react";
import { Step } from "./steps/Step";
import { plausibleEvent } from "../../utilities/helper";
import { PDFButton } from "./PDFDocument";

type ChairInfoButtonSettings = {
    key: string;
    text: string;
    targetStep: Step;
};

export const ChairInfoButton = () => {
    const { step, setStep } = useStep();
    const { chair } = useChair();
    const { addItem } = useCart();
    const inputRef = useRef<HTMLInputElement>(null);
    const [settings, setSettings] = useState<ChairInfoButtonSettings>({
        key: "select",
        text: "Auswählen",
        targetStep: Step.OVERVIEW,
    });
    const [success, setSuccess] = useState<boolean>(false);

    useEffect(() => {
        if (step !== Step.OVERVIEW) {
            if (chair.variant === undefined) {
                setSettings({
                    key: "variant",
                    text: "Variante auswählen",
                    targetStep: Step.VARIANT,
                });
            } else if (chair.frame === undefined || chair.frame.texture === undefined) {
                setSettings({
                    key: "frame",
                    text: "Gestell auswählen",
                    targetStep: Step.FRAME,
                });
            } else if (chair.cover === undefined) {
                setSettings({
                    key: "cover",
                    text: "Bezug auswählen",
                    targetStep: Step.COVER,
                });
            } else if (chair.extra === undefined) {
                setSettings({
                    key: "accessory",
                    text: "Zubehör auswählen",
                    targetStep: Step.ACCESSORY,
                });
            } else {
                setSettings({
                    key: "select",
                    text: "Übersicht",
                    targetStep: Step.OVERVIEW,
                });
            }
        } else if (chair.variant === undefined) {
            setSettings({
                key: "variant",
                text: "Variante auswählen",
                targetStep: Step.VARIANT,
            });
        } else if (chair.frame === undefined || chair.frame.texture === undefined) {
            setSettings({
                key: "frame",
                text: "Gestell auswählen",
                targetStep: Step.FRAME,
            });
        } else if (chair.cover === undefined) {
            setSettings({
                key: "cover",
                text: "Bezug auswählen",
                targetStep: Step.COVER,
            });
        } else if (chair.extra === undefined) {
            setSettings({
                key: "accessory",
                text: "Zubehör auswählen",
                targetStep: Step.ACCESSORY,
            });
        } else {
            setSettings({
                key: "cart",
                text: "In den Warenkorb",
                targetStep: Step.CART,
            });
        }
    }, [step, chair]);

    const getId = () => {
        return `${chair.id}-${chair.modelId}-${chair.cover.className}-${chair.cover.catalog.id}-${chair.cover.color.id}-${chair.frame.id}-${chair.frame.texture.name}-${chair.extra.articleID}`;
    };

    const handleAddToCartIndicator = async () => {
        if (!success) {
            setSuccess(true);
            await new Promise((f) => setTimeout(f, 500));
            setSuccess(false);
        }
    };

    return (
        <div className={"chair-info-button-container"}>
            {settings.key === "cart" ? (
                <>
                    <input type={"text"} size={1} className={"number-of-items"} defaultValue={1} ref={inputRef} />
                    <span className={"accent"}>Stk.</span>
                </>
            ) : null}
            <div className={"buttons-container"}>
                <button
                    className={`button secondary icon-button chair-info-button ${settings.key} ${
                        success ? "success" : ""
                    }`}
                    onClick={(e) => {
                        e.currentTarget.blur();
                        if (settings.targetStep === Step.CART) {
                            const count = Number(inputRef.current.value.replace(/[^0-9]/g, ""));
                            addItem({ chair: chair, count: count, id: getId() });
                            plausibleEvent("add-to-cart", `${chair.modelName} ${chair.variant} - ${count}`);
                            handleAddToCartIndicator();
                        } else {
                            setStep(settings.targetStep);
                        }
                    }}
                >
                    {settings.text}
                </button>
                {settings.key === "cart" ? (
                    <>
                        <button
                            className={"button primary goto-cart"}
                            onClick={() => {
                                const url = new URL(window.location.href);
                                url.searchParams.set("cart", "1");
                                window.history.pushState({ cart: "1" }, "", url);
                                setStep(Step.CART);
                            }}
                        >
                            Zum Warenkorb
                        </button>
                        <PDFButton />
                    </>
                ) : null}
            </div>
        </div>
    );
};
